{
  "datatable": {
    "rowsPerPage": "Рядків на сторінці"
  },
  "department": {
    "addDepartment": "Додати Департамент",
    "createNewDepartment": "Створити новий департамент",
    "departmentAdmin": "Адміністратор Департаменту",
    "departmentName": "Назва Департаменту",
    "institution": "Назва Закладу",
    "institutionName": "Назва Закладу",
    "searchDepartments": "Пошук департаменту",
    "thisFieldIsRequired": "Обов'язкове Поле"
  },
  "general": {
    "accessDenied": "Немає Доступу",
    "add": "Додати",
    "back": "Назад",
    "cancel": "Скасувати",
    "close": "Закрити",
    "dateAdded": "Додано",
    "dateUpdated": "Оновлено",
    "delete": "Видалити",
    "edit": "Редагувати",
    "loading": "Завантаження ...",
    "no": "Ні",
    "noData": "Немає Данных",
    "ok": "ОК",
    "remove": "Видалити",
    "save": "Зберегти",
    "selectAll": "Обрати Все",
    "yes": "Так",
    "selectGender": "Вибрати стать",
    "gender": {
      "male": "Чоловічий",
      "female": "Жіночий"
    }
  },
  "institution": {
    "contact": "Контакт",
    "createNewInstitution": "Створити новий заклад",
    "name": "Ім'я",
    "region": "Регіон",
    "searchInstitutions": "Пошук закладів",
    "switch": "Змінити",
    "switchedTo": "Заклад змінено на",
    "unableToSwitch": "Неможливо змінити"
  },
  "menu": {
    "departments": "Департамент",
    "home": "Головна",
    "institutions": "Заклади",
    "procedure": "Процедура",
    "procedures": "Процедури",
    "scheduling": "Розклад",
    "users": "Користувачі"
  },
  "procedure": {
    "allSteps": "Всі Кроки",
    "authors": "Автор(и)",
    "category": "Категорія",
    "createNewStep": "Створити Новий Крок",
    "defineFeedback": "Дати Відгук",
    "description": "Опис",
    "disableProcedure": "Вимкнути Процедуру",
    "addProceduresInformation": "Додати Інформацію про процедуру",
    "editProceduresInformation": "Редагувати Інформацію про процедуру",
    "duplicateStartEndStepWarning": "Допускається лише 1 початковий та 1 кінцевий крок",
    "information": "Інформація",
    "language": "Мова",
    "languagesAvailable": "Доступні Мови",
    "media": "Медіа",
    "name": "Назва",
    "owner": "Власник",
    "procedureCategory": "Категорія Процедури",
    "procedureLanguage": "Мова Процедури",
    "procedureName": "Назва Процедури",
    "procedureNotFound": "Процедура не знайдена",
    "public": "Загальна",
    "publicPrivate": "Загальні/Закриті",
    "revisionHistory": "Історія Ревізій",
    "searchSteps": "Пошук кроків",
    "seeFeedback": "Побачити Відгук",
    "statistics": "Статистика",
    "step": "Крок",
    "thisFieldIsRequired": "Обов'язкове Поле",
    "unableToLoad": "Виникла проблема під час завантаження процедур",
    "viewAs": "Переглянути Як"
  },
  "procedures": {
    "addProcedure": "Додати процедуру",
    "category": "Категорія",
    "deleteProcedure": "Видалити процедуру",
    "department": "Департамент",
    "filter": "Фільтр",
    "private": "Закриті",
    "procedures": "Процедури",
    "public": "Загальні",
    "publicPrivate": "Загальні/Закриті",
    "searchProcedures": "Пошук процедур",
    "sort": "Сортування"
  },
  "step": {
    "addDescription": "Додати Опис",
    "addParentStep": "Додати батьківський крок",
    "chooseParentSep": "Оберіть батьківський крок",
    "chooseStepOption": "Оберіть опцію кроку",
    "chooseTransitionType": "Оберіть тип переходу",
    "chooseType": "Обрати тип",
    "description": "Опис",
    "dropFilesOrClickToUpload": "Перетягніть файли сюда або нажміть Завантажити",
    "editStep": "Редагувати Крок",
    "insertMaxValue": "Введіть МАКС значення",
    "insertMinValue": "Введіть МІН значення",
    "insertOption": "Ввести опцію",
    "option": "Опція",
    "owner": "Власник",
    "parentStep": "Батьківський крок",
    "previousStep": "Попередній крок",
    "saveMedia": "Зберегти Медіафайли",
    "stepMedia": "Медіафайли кроку",
    "transitionToNextStep": "Переход на наступний крок",
    "transitionType": "Тип переходу",
    "type": "Тип",
    "value": "Значення",
    "viewInProcedure": "Переглянути В Процедурі",
    "error": {
      "WONT_REACH_END": "Немає шляху до КІНЦЯ",
      "EXIT_NOT_IN_USE": "Невикористаний вихід",
      "NO_PARENT_SET": "Немає попереднього кроку",
      "PARENT_NOT_EXITS": "Визначений батьківський крок не існує",
      "DUPLICATE_START": "Процедура може мати лише один крок ПОЧАТОК",
      "DUPLICATE_END": "Процедура може мати лише один крок КІНЕЦЬ"
    }
  },
  "user": {
    "accountSettings": "Налаштування акаунту",
    "chooseUserRole": "Обрати Роль Користувача",
    "contact": "Контакт",
    "contactInformation": "Контактна інформація",
    "dateOfBirth": "Дата Народження",
    "department": "Департамент",
    "emails": "Емейл Користувача",
    "emailsDescription": "Введіть 1 або більше емейлів, розділених крапкою з комою. Запрошення зареєструватися з обраною користувацькою ролью буде надіслано на емейл.",
    "filter": "Фільтр",
    "gender": "Стать",
    "institution": "Заклад",
    "institutionalAdmin": "Адміністратор Закладу",
    "institutionAndDepartment": "Заклад та Департамент",
    "inviteUsers": "Запросити Користувача",
    "logOut": "Вийти",
    "nurse": "Медсестра",
    "password": "Пароль",
    "patient": "Паціент",
    "resetPassword": "Скинути Пароль",
    "resetRequestSentTo": "Лист з інформацією про новий пароль відправлено на",
    "searchUsers": "Пошук користувача",
    "sendResetPasswordEmailTo": "Відправити листа з інформацією про новий пароль на",
    "sort": "Сортування",
    "subscription": "Підписка",
    "thisFieldIsRequired": "Обов'язкове Поле",
    "user": "Користувач",
    "userDetailsUpdated": "Дані про користувача оновлено",
    "userInformation": "Користувацька інформація",
    "userRole": "Роль Користувача"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  }
}
